const breadCrumbsLabels = {
  individuals: 'individualsSidebar',
  testimonials: 'Testimonials',
  kyc: 'KYC',
  'mine-profile': 'Mine Profile',
  dd: 'DD Systems',
  events: 'Events',
  event: 'All Events',
  scl: 'Mine Sites',
  village: 'Villages',
  location: 'All Locations',
  documents: 'Documents',
  document: 'All Documents',
  incidents: 'Incidents',
  project: 'Projects',
  publishProject: 'Publish Data',
  sp: 'Supply Chain Policy',
  im: 'Internal Management',
  gm: 'Grievance Mechanism',
  scp: 'Supply Chain Actors',
  bpe: 'Supplier Engagement',
  stakeholder: 'Stakeholders',
  settings: 'Settings',
  sci: 'Supply Chain Integrity',
  lir: 'Local Information Relays',
  user: 'Users',
  amp: 'AMP List',
  modules: 'Modules',
  analysis: 'Analysis',
  'mine-operators': 'Mine Operators',
  'due-diligence': 'Due Diligence Documents',
  'corrective-actions': 'Corrective Actions',
  'data-store': 'Store',
  data: 'Data',
  entities: 'Entities',
  archives: 'Archives',
  locations: 'Locations',
  programs: 'Programs',
  'information-channels': 'Channels',
  'find-information': 'Query',
  'application-form': 'Application Form',
  'ownership-kyc': 'Ownership & KYC',
  linkedSubjects: 'Associated Information',
  initiatives: 'Initiatives',
  victims: 'Victims',
  pictures: 'Pictures',
}

export const renderBreadCrumbs = ({
  t = (s) => s,
  goTo = () => { },
  view = 'document',
  mod,
  isAnalysis = false,
  isView = false,
  sourceId,
  isDataStore = false,
  id,
  subjectName,
}) => {
  const items = [];

  const pushId = () => items.push({ label: id, onClick: () => { } });

  const addId = () => {
    if (id && id !== 'user') {
      pushId();
    }
  };

  switch (view) {
    case 'documents':
      items.push({ label: t(breadCrumbsLabels.modules), onClick: () => { } });
      items.push({ label: t(breadCrumbsLabels.linkedSubjects), onClick: () => { } });
      items.push({ label: t(breadCrumbsLabels.documents), onClick: () => goTo(`/app/${mod}/documents`) });

      if (id) {
        addId();
      }
      break;
    case 'pictures':
      items.push({ label: t(breadCrumbsLabels.modules), onClick: () => { } });
      items.push({ label: t(breadCrumbsLabels.linkedSubjects), onClick: () => { } });
      items.push({ label: t(breadCrumbsLabels.pictures), onClick: () => goTo(`/app/${mod}/pictures`) });

      if (id) {
        addId();
      }
      break;
    case 'stakeholders':
      items.push({ label: t(breadCrumbsLabels.modules), onClick: () => { } });
      items.push({ label: t(breadCrumbsLabels.linkedSubjects), onClick: () => { } });
      items.push({ label: t(breadCrumbsLabels.stakeholder), onClick: () => { } });
      break;
    case 'individuals':
      if (['tazama'.includes(mod)]) {
        items.push({ label: t(breadCrumbsLabels.modules), onClick: () => { } });
      }

      items.push({ label: t(breadCrumbsLabels.linkedSubjects), onClick: () => { } });
      items.push({ label: t(breadCrumbsLabels.individuals), onClick: () => goTo(`/app/${mod}/individuals`) });

      if (id) {
        pushId();
      }
      break;
    case 'victims':
      if (['tazama'.includes(mod)]) {
        items.push({ label: t(breadCrumbsLabels.modules), onClick: () => { } });
      }

      items.push({ label: t(breadCrumbsLabels.linkedSubjects), onClick: () => { } });
      items.push({ label: t(breadCrumbsLabels.individuals), onClick: () => goTo(`/app/${mod}/victims`) });

      if (id) {
        pushId();
      }
      break;
    case 'initiatives':
      if (['tazama'.includes(mod)]) {
        items.push({ label: t(breadCrumbsLabels.modules), onClick: () => { } });
      }

      items.push({ label: t(breadCrumbsLabels.linkedSubjects), onClick: () => { } });
      items.push({ label: t(breadCrumbsLabels.initiatives), onClick: () => goTo(`/app/${mod}/initiatives`) });

      if (id) {
        pushId();
      }
      break;
    case 'application-form':
      items.push({ label: t(breadCrumbsLabels.modules), onClick: () => { } });
      if (id !== 'user') {
        pushId();
      }
      items.push({ label: t(breadCrumbsLabels[view]), onClick: () => { } });
      return items;
    case 'find-information':
      if (isDataStore) {
        items.push({ label: t(breadCrumbsLabels.data), onClick: () => { } });
        items.push({ label: t(breadCrumbsLabels[view]), onClick: () => goTo(`/app/${mod}/find-information`) });
      }
      break;
    case 'information-channels':
      if (isDataStore) {
        items.push({ label: t(breadCrumbsLabels.data), onClick: () => { } });
        items.push({ label: t(breadCrumbsLabels[view]), onClick: () => goTo(`/app/${mod}/information-channels`) });
      }
      break;
    case 'archives':
      if (isDataStore) {
        items.push({ label: t(breadCrumbsLabels.data), onClick: () => { } });
        items.push({ label: t(breadCrumbsLabels["data-store"]), onClick: () => goTo(`/app/${mod}/data-store`) });
        items.push({ label: t(breadCrumbsLabels.archives), onClick: () => goTo(`/app/${mod}/data-store/archives`) });
      }
      break;
    case 'locations':
      if (isDataStore) {
        items.push({ label: t(breadCrumbsLabels.data), onClick: () => { } });
        items.push({ label: t(breadCrumbsLabels["data-store"]), onClick: () => goTo(`/app/${mod}/data-store`) });
        items.push({ label: t(breadCrumbsLabels.locations), onClick: () => goTo(`/app/${mod}/data-store/locations`) });
      }

      if (['tazama'].includes(mod)) { // linked subjects
        items.push({ label: t(breadCrumbsLabels.modules), onClick: () => { } });
        items.push({ label: t(breadCrumbsLabels.linkedSubjects), onClick: () => { } });
        items.push({ label: t(breadCrumbsLabels.locations), onClick: () => { } });
      }

      break;
    case 'entities':
      if (isDataStore) {
        items.push({ label: t(breadCrumbsLabels.data), onClick: () => { } });
        items.push({ label: t(breadCrumbsLabels["data-store"]), onClick: () => goTo(`/app/${mod}/data-store`) });
        items.push({ label: t(breadCrumbsLabels.entities), onClick: () => goTo(`/app/${mod}/data-store/entities`) });
      }
      break;
    case 'data-store':
      items.push({ label: t(breadCrumbsLabels.data), onClick: () => { } });
      items.push({ label: t(breadCrumbsLabels["data-store"]), onClick: () => goTo(`/app/${mod}/data-store`) });
      break;
    case 'programs':
      items.push({ label: t(breadCrumbsLabels.analysis), onClick: () => goTo(`/app/${mod}/${view}`) });
      items.push({ label: t(breadCrumbsLabels[view]), onClick: () => goTo(`/app/${mod}/${view}`) });
      items.push({ label: id });
      break;
    case 'amp':
      items.push({ label: t(breadCrumbsLabels.modules), onClick: () => goTo(`/app/${mod}/amp`) });
      items.push({ label: t(breadCrumbsLabels.amp), onClick: () => goTo(`/app/${mod}/amp`) });
      items.push({
        label: id,
        onClick: () => goTo(
          sourceId
            ? `/app/${mod}/analysis/amp/${id}/${sourceId}`
            : `/app/${mod}/analysis/amp/${id}`
        )
      });
      break;
    case 'settings':
      items.push({ label: t(breadCrumbsLabels.settings), onClick: () => goTo(`/app/${mod}/view/settings`) });
      break;
    case 'user':
    case 'users':
      items.push({ label: t(breadCrumbsLabels.user), onClick: () => goTo(`/app/${mod}/users`) });
      break;
    case 'project':
    case 'projects':
      if (id) {
        items.push({ label: t(breadCrumbsLabels.project), onClick: () => goTo(`/app/${mod}/projects`) });
        items.push({ label: id, onClick: () => { } });
        items.push({ label: t('Project Details'), onClick: () => { } });
      } else {
        items.push({ label: t(breadCrumbsLabels.project), onClick: () => goTo(`/app/${mod}/projects`) });
      }
      break;
    case 'publishProject':
      items.push({ label: t(breadCrumbsLabels.project), onClick: () => goTo(`/app/${mod}/projects`) });
      items.push({ label: id, onClick: () => { } });
      items.push({ label: t(breadCrumbsLabels.publishProject), onClick: () => { } });
      break;
    case 'dd':
      items.push({ label: t(breadCrumbsLabels.modules), onClick: () => { } });
      items.push({ label: t(breadCrumbsLabels[view]), onClick: () => { } });
      break;
    case 'im':
    case 'gm':
    case 'sp':
    case 'bpe':
    case 'sci':
      items.push({ label: t(breadCrumbsLabels.modules), onClick: () => { } });
      items.push({ label: t('My Organisation'), onClick: () => { } });
      items.push({ label: t(breadCrumbsLabels.dd), onClick: () => { } });
      items.push({ label: t(breadCrumbsLabels[view]), onClick: () => { } });
      break;
    case 'document':
      items.push({ label: t(breadCrumbsLabels.modules), onClick: () => goTo(`/app/${mod}/documents`) });
      items.push({ label: t(breadCrumbsLabels.documents), onClick: () => goTo(`/app/${mod}/documents`) });
      items.push({ label: t(breadCrumbsLabels.document), onClick: () => goTo(`/app/${mod}/documents`) });
      addId();
      break;
    case 'lir':
      items.push({ label: t(breadCrumbsLabels.modules), onClick: () => goTo(`/app/${mod}/lir`) });
      items.push({ label: t(breadCrumbsLabels.stakeholder), onClick: () => goTo(`/app/${mod}/lir`) });
      items.push({ label: t(breadCrumbsLabels.lir), onClick: () => goTo(`/app/${mod}/lir`) });
      addId();
      break;
    case 'due-diligence':
      items.push({ label: t(breadCrumbsLabels['due-diligence']), onClick: () => goTo(`/app/${mod}/due-diligence`) });
      break;
    case 'event':
    case 'events':
      if (isDataStore) {
        items.push({ label: t(breadCrumbsLabels.data), onClick: () => { } });
        items.push({ label: t(breadCrumbsLabels["data-store"]), onClick: () => goTo(`/app/${mod}/data-store`) });
        items.push({ label: t(breadCrumbsLabels.events), onClick: () => goTo(`/app/${mod}/data-store/events`) });
      } else {
        items.push({ label: t(breadCrumbsLabels.modules), onClick: () => goTo(`/app/${mod}/events`) });
        items.push({ label: t(breadCrumbsLabels.events), onClick: () => goTo(`/app/${mod}/events`) });
        items.push({ label: t(breadCrumbsLabels.event), onClick: () => goTo(`/app/${mod}/events`) });
        if (id) {
          pushId();
        }
      }
      break;
    case 'incident':
    case 'incidents':
      if (['tazama'.includes(mod)]) {
        items.push({ label: t(breadCrumbsLabels.modules), onClick: () => { } });
      }

      items.push({ label: t(breadCrumbsLabels.events), onClick: () => goTo(`/app/${mod}/incidents`) });
      items.push({ label: t(breadCrumbsLabels.incidents), onClick: () => goTo(`/app/${mod}/incidents`) });
      addId();
      break;
    case 'testimonials':
      items.push({ label: t(breadCrumbsLabels.modules), onClick: () => { } });
      items.push({ label: t(breadCrumbsLabels.events), onClick: () => goTo(`/app/${mod}/testimonials`) });
      items.push({ label: t(breadCrumbsLabels.testimonials), onClick: () => goTo(`/app/${mod}/testimonials`) });
      addId();
      break;
    case 'corrective-action':
    case 'corrective-actions':
      if (['tazama'.includes(mod)]) {
        items.push({ label: t(breadCrumbsLabels.modules), onClick: () => { } });
      }

      items.push({ label: t(breadCrumbsLabels.events), onClick: () => goTo(`/app/${mod}/corrective-actions`) });
      items.push({ label: t(breadCrumbsLabels['corrective-actions']), onClick: () => goTo(`/app/${mod}/corrective-actions`) });
      addId();
      break;
    case 'location':
      if (['tazama'].includes(mod)) { // linked subjects
        items.push({ label: t(breadCrumbsLabels.modules), onClick: () => { } });
        items.push({ label: t(breadCrumbsLabels.linkedSubjects), onClick: () => { } });
        items.push({ label: t(breadCrumbsLabels.locations), onClick: () => goTo(`/app/${mod}/locations`) });
      } else {
        items.push({ label: t(breadCrumbsLabels.modules), onClick: () => goTo(`/app/${mod}/locations`) });
        items.push({ label: t(breadCrumbsLabels.locations), onClick: () => goTo(`/app/${mod}/locations`) });
        items.push({ label: t('Other'), onClick: () => goTo(`/app/${mod}/locations`) });
      }
      addId();
      break;
    case 'village':
      items.push({ label: t(breadCrumbsLabels.modules), onClick: () => goTo(`/app/${mod}/village`) });
      items.push({ label: t(breadCrumbsLabels.locations), onClick: () => goTo(`/app/${mod}/village`) });
      items.push({ label: t(breadCrumbsLabels.village), onClick: () => goTo(`/app/${mod}/village`) });
      addId();
      break;
    case 'ownership-kyc':
      if (mod === 'tif') {
        if (id === 'user') {
          items.push({ label: t(breadCrumbsLabels.modules), onClick: () => { } });
          items.push({ label: t('Ownership & KYC') });
        } else {
          items.push({ label: t(breadCrumbsLabels.modules), onClick: () => goTo(`/app/${mod}/amp`) });
          items.push({ label: t(breadCrumbsLabels.amp), onClick: () => goTo(`/app/${mod}/amp`) });
          items.push({
            label: id,
            onClick: () => goTo(
              sourceId
                ? `/app/${mod}/analysis/amp/${id}/${sourceId}`
                : `/app/${mod}/analysis/amp/${id}`
            )
          });
          // items.push({
          //   label: t('Subject Analysis'),
          //   onClick: () => goTo(`/app/${mod}/analysis/amp/${id}`),
          // });
          items.push({ label: t(breadCrumbsLabels[view]) });
        }
        return items;
      } else {
        items.push({ label: t(breadCrumbsLabels.location), onClick: () => goTo(`/app/${mod}/locations`) });
        items.push({ label: t(breadCrumbsLabels.scl), onClick: () => goTo(`/app/${mod}/scl`) });
      }
      break;
    case 'mine-profile':
      if (mod === 'tif') {
        if (id === 'user') {
          items.push({ label: t(breadCrumbsLabels.modules), onClick: () => { } });
          items.push({ label: t(breadCrumbsLabels[view]) });
        } else {
          items.push({ label: t(breadCrumbsLabels.modules), onClick: () => goTo(`/app/${mod}/amp`) });
          items.push({ label: t(breadCrumbsLabels.amp), onClick: () => goTo(`/app/${mod}/amp`) });
          items.push({
            label: id,
            onClick: () => goTo(
              sourceId
                ? `/app/${mod}/analysis/amp/${id}/${sourceId}`
                : `/app/${mod}/analysis/amp/${id}`
            )
          });
          // items.push({
          //   label: t('Subject Analysis'),
          //   onClick: () => goTo(`/app/${mod}/analysis/amp/${id}`),
          // });
          items.push({ label: t(breadCrumbsLabels[view]) });
        }
        return items;
      } else {
        items.push({ label: t(breadCrumbsLabels.location), onClick: () => goTo(`/app/${mod}/locations`) });
        items.push({ label: t(breadCrumbsLabels.scl), onClick: () => goTo(`/app/${mod}/scl`) });
      }
      break;
    case 'stakeholder':
      if (['tazama'].includes(mod)) { // linked subjects
        items.push({ label: t(breadCrumbsLabels.modules), onClick: () => { } });
        items.push({ label: t(breadCrumbsLabels.linkedSubjects), onClick: () => { } });
        items.push({ label: t(breadCrumbsLabels.stakeholder), onClick: () => goTo(`/app/${mod}/stakeholders`) });
      } else {
        items.push({ label: t(breadCrumbsLabels.modules), onClick: () => goTo(`/app/${mod}/stakeholders`) });
        items.push({ label: t(breadCrumbsLabels.stakeholder), onClick: () => goTo(`/app/${mod}/stakeholders`) });
        items.push({ label: t('Other'), onClick: () => goTo(`/app/${mod}/stakeholders`) });
      }

      addId();
      break;
    case 'scp':
      items.push({ label: t(breadCrumbsLabels.modules), onClick: () => goTo(`/app/${mod}/scp`) });
      items.push({ label: t(breadCrumbsLabels.stakeholder), onClick: () => goTo(`/app/${mod}/scp`) });
      items.push({ label: t(breadCrumbsLabels.scp), onClick: () => goTo(`/app/${mod}/scp`) });
      if (id) {
        items.push({
          label: id,
          onClick: () => goTo(
            sourceId
              ? `/app/${mod}/analysis/scp/${id}/${sourceId}`
              : `/app/${mod}/analysis/scp/${id}`
          )
        });
      }
      break;
    case 'mine-operators':
      items.push({ label: t(breadCrumbsLabels["mine-operators"]), onClick: () => goTo(`/app/${mod}/mine-operators`) });
      break;
    case 'kyc':
      items.push({ label: t(breadCrumbsLabels.modules), onClick: () => { } });
      items.push({ label: t('My Organisation'), onClick: () => { } });
      items.push({ label: t(breadCrumbsLabels.kyc), onClick: () => { } });
      break;
    case 'scl':
      items.push({ label: t(breadCrumbsLabels.modules), onClick: () => goTo(`/app/${mod}/scl`) });
      items.push({ label: t(breadCrumbsLabels.locations), onClick: () => goTo(`/app/${mod}/scl`) });
      items.push({ label: t(breadCrumbsLabels.scl), onClick: () => goTo(`/app/${mod}/scl`) });
      if (id) {
        items.push({
          label: id,
          onClick: () => goTo(
            sourceId
              ? `/app/${mod}/analysis/scl/${id}/${sourceId}`
              : `/app/${mod}/analysis/scl/${id}`
          )
        });
      }
      break;
    default:
  }

  if (isView) {
    if (view === 'amp') {
      items.push({ label: t('Application Form') });
    }
  } else if (isAnalysis) {
    items.push({ label: t('Summary') });
  }

  return items.filter((v) => !!v.label);
}
